export default __webpack_public_path__ + "static/words-fc2010e6a52c3c282569b4715eedae10.png";